module.exports = __webpack_public_path__ + "img/H3.66311c6b.png";